
import { defineComponent } from 'vue'
import BaseInput from '@/components/BaseInput.vue'
import IconPercentage from '@/components/IconPercentage.vue'

export default defineComponent({
  components: {
    BaseInput,
    IconPercentage
  },

  props: {
    id: {
      default: '',
      type: String
    },

    modelValue: {
      default: '',
      type: [String, Number]
    },

    placeholder: {
      default: '',
      type: String
    },

    step: {
      default: 0.01,
      type: Number
    },

    required: {
      default: false,
      type: Boolean
    }
  },

  emits: ['update:modelValue']
})
